import { UserType } from '../constants/constants';
import { useUser } from '../context/UserContext';
import { ParameterEntityType } from '../interface/parameters';
import { useFetchSystemParameters } from './useFetchSystemParameters';

/**
 * Restricted users are only allowed what System -> Restricted User Permissions grants them.
 * A missing or null flag denies the operation, matching the backend, which coerces the flag with `!!`.
 * Which matter requests a restricted user can reach is decided by the API, which only returns the ones
 * they are part of, so the edit flag is not narrowed again on the client.
 */
export const useRestrictedUserMatterPermissions = () => {
  const { user } = useUser();
  const isRestrictedUser = user?.userType === UserType.RESTRICTED;
  const { data, isLoading } = useFetchSystemParameters({
    parametersToGet: ParameterEntityType.RESTRICTED_USER,
    enabled: isRestrictedUser,
  });

  const restrictedUserParameters = data?.parameters?.restrictedUserParameters;

  return {
    canCreateMatterRequests:
      !isRestrictedUser || Boolean(restrictedUserParameters?.allowCreateMatters),
    canEditMatterRequests: !isRestrictedUser || Boolean(restrictedUserParameters?.allowEditMatters),
    isLoading: isRestrictedUser && isLoading,
  };
};
